var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpritzenOhneAbluftanlage = function SvgSpritzenOhneAbluftanlage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Spritzen_ohne_Abluftanlage_svg__Ebene_2",
    viewBox: "0 0 90.57 85.42"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Spritzen_ohne_Abluftanlage_svg__cls-2{fill:currentColor}"))), /*#__PURE__*/React.createElement("g", {
    id: "Spritzen_ohne_Abluftanlage_svg__Layer_1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.42 0 1.4 81.75l-.36.34 3.14 3.33L90.21 3.67l.36-.34z",
    className: "Spritzen_ohne_Abluftanlage_svg__cls-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.03 54.85H20.25a1.14 1.14 0 1 0 0 2.28h45.79a1.14 1.14 0 1 0 0-2.28Z",
    className: "Spritzen_ohne_Abluftanlage_svg__cls-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.03 57.38H20.25c-.77 0-1.39-.62-1.39-1.39s.62-1.39 1.39-1.39h45.79c.77 0 1.39.62 1.39 1.39s-.62 1.39-1.39 1.39Zm-45.78-2.29c-.49 0-.89.4-.89.89s.4.89.89.89h45.79c.49 0 .89-.4.89-.89s-.4-.89-.89-.89zM49.38 79.82H36.89a1.14 1.14 0 1 0 0 2.28h12.49a1.14 1.14 0 1 0 0-2.28",
    className: "Spritzen_ohne_Abluftanlage_svg__cls-2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.38 82.35H36.89c-.77 0-1.39-.62-1.39-1.39s.62-1.39 1.39-1.39h12.49c.77 0 1.39.62 1.39 1.39s-.62 1.39-1.39 1.39M36.9 80.07c-.49 0-.89.4-.89.89s.4.89.89.89h12.49c.49 0 .89-.4.89-.89s-.4-.89-.89-.89zM57.71 67.33H28.57a1.14 1.14 0 1 0 0 2.28h29.14a1.14 1.14 0 1 0 0-2.28",
    className: "Spritzen_ohne_Abluftanlage_svg__cls-2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.71 69.86H28.57c-.77 0-1.39-.62-1.39-1.39s.62-1.39 1.39-1.39h29.14c.77 0 1.39.62 1.39 1.39s-.62 1.39-1.39 1.39m-29.14-2.28c-.49 0-.89.4-.89.89s.4.89.89.89h29.14c.49 0 .89-.4.89-.89s-.4-.89-.89-.89z",
    className: "Spritzen_ohne_Abluftanlage_svg__cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 11.05h83.78v29.68H1.25z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: 10,
      strokeWidth: "2.5px"
    }
  })));
};
export default SvgSpritzenOhneAbluftanlage;